import {TimedShuttleDefinitionScreen} from "@src/features/timed-shuttles/ui/screens/timed-shuttle-definitions";
import {TimedShuttlesByDateScreen} from "@src/features/timed-shuttles/ui/screens/timed-shuttle-by-date-screen";
import {TimedShuttlesScreen} from "@src/features/timed-shuttles/ui/screens/timed-shuttle-screen";
import * as React from "react";
import {type LoaderFunctionArgs, redirect, type RouteObject} from "react-router-dom";
import { TimedShuttleAllDefinitionsScreen } from "./ui/screens/timed-shuttle-all-definitions-screen";
import { TimedShuttlesInstancesScreen } from "./ui/screens/timed-shuttle-instances-screen";


export function getTimedShuttlesRoutesDefinitions(): RouteObject[] {
	return [
		{
			index:   true,
			element: <TimedShuttlesInstancesScreen/>
		  },
		{
			path: "history",
			element: <TimedShuttlesByDateScreen/>,
		},
		{
			path: "definitions",
			children: [
				{
					index: true,
					element: <TimedShuttleAllDefinitionsScreen/>,
				},
				{
					path: ":definitionId",
					element: <TimedShuttleDefinitionScreen/>,
				}
			]
		},
	] satisfies RouteObject[];
}
